import { isObject } from '@Sage/ssm-utils';

import { getCrossID } from 'utils/filters';
export const getSelectedFilters = (selected, entity) => {
    if (!selected || Object.keys(selected).length === 0) return [];

    // When there is relatedEntities selector needs to be treated as an object.
    let isArray = Array.isArray(selected?.[Object.keys(selected)?.[0]]);

    let newSelected = [];
    if (isArray) {
        newSelected = Object.keys(selected).reduce((arr, key) => {
            const isArray = Array.isArray(selected[key].options);
            if (isArray && selected[key].options?.length > 0) {
                arr = [...arr, ...selected[key].options];
            }
            return arr;
        }, []);
    } else if (selected?.[Object.keys(selected)?.[0]]) {
        newSelected = Object.keys(selected).reduce((arr, key) => {
            if (selected[key].options && Array.isArray(selected[key].options)) {
                arr = [...arr, ...selected[key].options];
            } else if (selected[key].options && isObject(selected[key].options)) {
                Object.keys(selected[key].options).forEach((key2) => {
                    selected[key].options[key2].options.forEach((filterId) => {
                        if (entity && key === entity?.entity) arr.push(filterId);
                        else arr.push(getCrossID(filterId, key));
                    });
                });
            }
            return arr;
        }, []);
    }

    return newSelected;
};

const OPEN_SELECT_CONTROL_SELECTOR = '.hoi-poi-select__control--menu-is-open';

/** Closes open Select menus whose controls live inside `container`. */
export const closeOpenSelectMenus = (container) => {
    if (!container) {
        return;
    }

    container.querySelectorAll(OPEN_SELECT_CONTROL_SELECTOR).forEach((control) => {
        control.querySelector('input')?.blur();
    });
};
